import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllIcon = async () => {
  const url = endpoints.ICON_LIST;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const iconService = {
    getAllIcon
}

export default iconService;